import { gql } from '@/__generated__/gql';

export const ALLOCATOR_PAGE_CREATE_ALLOCATIONS_MUTATION = gql(`
  mutation AllocatorPageCreateAllocations($data: [AllocationEntityCreateDto!]!) {
    createAllocations(data: $data) {
      id
    }
  }
`);

export const ALLOCATOR_PAGE_UPDATE_ALLOCATIONS_MUTATION = gql(`
  mutation AllocatorPageUpdateAllocations($data: [UpdateAllocationInput!]!) {
    updateAllocations(data: $data) {
      id
    }
  }
`);

export const ALLOCATOR_PAGE_DELETE_ALLOCATION_MUTATION = gql(`
  mutation AllocatorPageDeleteAllocation($allocationId: String!) {
    deleteAllocation(allocationId: $allocationId) {
      id
    }
  }
`);

export const ALLOCATOR_PAGE_BULK_ALLOCATIONS_QUERY = gql(`
  query AllocatorPageBulkAllocations($input: BulkAllocationsQueryInput!) {
    bulkAllocations(input: $input) {
      total
      filters {
        name
        type
        value
        enabled
        count
      }
      totalAmount {
        length
        amount
      }
      investment {
        id
        name
        managerId
      }
      allocations {
        id
        existingCommitment
        editable
        allocationStatus
        committedCapital
        decision
        reason
        override
        suitability
        proposalType
        suitabilityCriteria {
          label
          value
        }
        preAllocationStatus {
          alreadyCommitted
          committedAt
          terminated
          terminatedAt
          internalReviewRejections
          internalReviewRejectionAt
        }
        investment {
          id
          name
          type
          minimum
        }
        group {
          id
          name
          primaryEntity {
            id
            entityName
          }
          legalEntities {
            id
            entityName
            proposalType
            committedCapital
          }
        }
        legalEntity {
          id
          entityName
          overallCapacity
          assetClassCapacity
          fundBiteSize
          directBiteSize
          ignoreBiteSize
          groupId
          family {
            id
            name
          }
          advisor {
            firstName
            lastName
            initials
          }
        }
      }
    }
  }
`);

export const ALLOCATOR_PAGE_BULK_ALLOCATIONS_TOTAL_QUERY = gql(`
  query AllocatorPageBulkAllocationsTotal($input: BulkAllocationsQueryInput!) {
    bulkAllocations(input: $input) {
      total
    }
  }
`);

export const ALLOCATOR_PAGE_ADVISORS_QUERY = gql(`
  query AllocatorPageAdvisors {
    Advisors {
      id
      firstName
      lastName
      initials
    }
  }
`);
